import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";

// Public
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Divisions from "@/pages/Divisions";
import Collection from "@/pages/Collection";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

// Admin
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import ProductForm from "@/pages/admin/ProductForm";
import AdminMessages from "@/pages/admin/AdminMessages";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PublicShell = ({ children }) => (
  <CartProvider>
    <Header />
    <CartDrawer />
    <main>{children}</main>
    <Footer />
  </CartProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ScrollToTop />
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="products/new" element={<ProductForm />} />
              <Route path="products/:id/edit" element={<ProductForm />} />
              <Route path="messages" element={<AdminMessages />} />
            </Route>

            {/* Public */}
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/divisions" element={<PublicShell><Divisions /></PublicShell>} />
            <Route path="/sneakers" element={<PublicShell><Collection category="sneakers" /></PublicShell>} />
            <Route path="/perruques" element={<PublicShell><Collection category="wigs" /></PublicShell>} />
            <Route path="/haute-couture" element={<PublicShell><Collection category="couture" /></PublicShell>} />
            <Route path="/epicerie" element={<PublicShell><Collection category="epicerie" /></PublicShell>} />
            <Route path="/patisserie" element={<PublicShell><Collection category="patisserie" /></PublicShell>} />
            <Route path="/printing" element={<PublicShell><Collection category="printing" /></PublicShell>} />
            <Route path="/sneakers/:slug" element={<PublicShell><ProductDetail /></PublicShell>} />
            <Route path="/produit/:slug" element={<PublicShell><ProductDetail /></PublicShell>} />
            <Route path="/a-propos" element={<PublicShell><About /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
          </Routes>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
